import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { getConfig } from "./api"
import newStore from "./newStore"
import { ErrorBoundary } from "react-error-boundary"
import Page404 from "pages/Page404"
import "./i18n"

function Index() {
  useEffect(() => {
    getConfig()
      .then(res => {
        newStore.setState({
          logo: { sm: res.logoSm, lg: res.logoLg },
          colors: res.colors,
        })
      })
      .catch(() => {
        // Backend no disponible — la app sigue funcionando sin config
      })
  }, [])

  return (
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={() => <Page404 error={true} />}>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  )
}

ReactDOM.render(<Index />, document.getElementById("root"))
serviceWorker.unregister()
